<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    :action="uploadFile"
    :success-text="successMessage"
    @closed="$emit('closed')"
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <div v-show="!successMessage">
      <div class="ml-1 mb-2">
        <a @click.stop="onDownloadFile">
          <u>Скачать Шаблон файла</u>
        </a>
      </div>
      <BFileInput
        v-model="file"
        :disabled="isLoading"
        :loading="isLoading"
        :label="'Файл'"
        small-chips
        show-size
        v-on="$listeners || {}"
        @change="onChange"
      >
        <template v-for="(_, key) in $scopedSlots" #[key]="props">
          <slot v-bind="props" :data="getData(props.item)" :name="key" />
        </template>
      </BFileInput>
    </div>
    <div class="pt-5 font-italic">
      <p>
        Столбец "Группа" должен содержать название группы, которую необходимо создать (обновить).
        Строка с заполненным наименованием обозначает область видимости для группы.
      </p>
      <p>
        Столбец "Права" должен содержать список прав, которые необходимо назначить пользователям создаваемой группы.
        Право указывается в виде "lk:passport:list", это значение можно скопировать в административной части ЛК.
        Если в группе должно быть назначено несколько прав, то следующие записи указываются на следующей строке
        (по 1 на строку)
      </p>
      <p>
        Столбец "Пользователи" должен содержать список пользователей, которых необходимо добавить в создаваемую группу.
        Если в группу должно быть включено несколько пользователей,
        то следующие пользователи указываются на следующей строке (по 1 на строку)
      </p>
      <p>
        Столбец "АТЕ" должен содержать список кодов объектов АТЕ, к которым у пользователей будут применяться права.
        Каждый код АТЕ указывается в отдельной строке.
      </p>
      <p>
        Столбец "Проверять АТЕ пользователей" должен содержать одну запись "true"
        или "false" в строке совпадающей со строкой названия группы,
        для которой необходимо проверять принадлежность прав к АТЕ пользователя.
      </p>
    </div>

    <div
      v-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import { PermissionsGroupsApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'
import BFileInput from '@/components/forms/BFileInput.vue'
import { downloadLinkByPost } from '@/helpers/downloadBlob'

const SUCCESS_MESSAGE = 'Файл будет обработан в фоновом режиме. Статус его обработки будет получен в уведомлениях системы.'

export default {
  name: 'UploadPermissionGroupsFileModal',
  components: {
    BModalConfirm,
    BFileInput,
  },
  titleText: 'Импорт групп с правами',
  data: () => ({
    isLoading: false,
    errorMessage: null,
    successMessage: null,
    file: null,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
        .then(() => !!this.successMessage)
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
    async onDownloadFile() {
      this.errorMessage = null
      this.isLoading = true

      try {
        const api = new PermissionsGroupsApi()
        await downloadLinkByPost(api.downloadTemplateuUploadPermissionsURL(), {}, 'Шаблон импорта групп с правами.xlsx')
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
    async uploadFile() {
      const api = new PermissionsGroupsApi()
      await api.uploadPermissions(this.file)
      this.successMessage = SUCCESS_MESSAGE
      this.close()
      this.$emit('submit')
    },
    onChange(file) {
      this.file = file
    },
  },
}
</script>
